module.exports = __webpack_public_path__ + "static/media/Krombacher-SansRegular.157b2eaa.woff2";